import {WorkingTimeTimelineDayContent} from "../timelineTypes";
import {htmlEscape} from "@/shared/utils/string";
import {formatHalfDay} from "@/shared/utils/datefunctions";

/**
 * Component to display holiday information in a timeline day.
 * This component is used inside <code>TimelineDay</code> to render holiday information for a specific day. If available, this component is appended to the day container.
 *
 * For an overview of the timeline architecture, have a look into the UML diagram "timeline_web_components.png"
 */
export class CombinedTimelineDayHoliday extends HTMLElement {
	private _timelineDay: WorkingTimeTimelineDayContent;

	set timelineDay(value: WorkingTimeTimelineDayContent) {
		this._timelineDay = value;
	}

	/**
	 * Main entry point to render the holiday information.
	 */
	public connectedCallback(): void {
		// timeline day (content) and holiday are required to render this component
		if (!this._timelineDay || !this._timelineDay.holiday) {
			return;
		}

		const {holiday} = this._timelineDay;
		const escapedHolidayDescription = htmlEscape(holiday.description);

		const div = document.createElement("div");
		div.innerHTML = `
			<span class="mr-5"><i class="fal fa-calendar-check position-left"></i>${escapedHolidayDescription}</span>
			${formatHalfDay(holiday.halfDay)}
		`;
		this.append(div);
	}
}
